import { render } from "./IconMessage.vue?vue&type=template&id=78d258b8"
import script from "./IconMessage.vue?vue&type=script&lang=js"
export * from "./IconMessage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bapman/Sites/telemac-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__